export const normalizeAttackTemplatePlatform = value =>
    String(value ?? '').trim().toLowerCase() === 'e4k' ? 'e4k' : 'gge'

export const buildSavedAttackTemplatesUrl = platform =>
    `/saved-attack-templates?platform=${encodeURIComponent(normalizeAttackTemplatePlatform(platform))}`
